import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { pathname } = useLocation();

  // 高亮当前所在页对应的导航按钮
  const onHome = pathname === '/';
  const onBlog = pathname.startsWith('/blog');
  const navBase = 'text-sm transition-colors rounded-full px-4 py-1.5';
  const navActive = 'font-medium text-white bg-slate-900 hover:bg-indigo-600';
  const navGhost = 'text-slate-600 hover:text-indigo-600 hover:bg-slate-100';

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2">
            <img src="/favicon.ico" alt="Teegal" className="w-6 h-6" />
            <span className="text-lg font-semibold tracking-tight text-slate-800 hover:text-indigo-600 transition-colors">
              Teegal
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-3">
            <a href="/" className={`${navBase} ${onHome ? navActive : navGhost}`}>
              首页
            </a>
            <a href="/blog" className={`${navBase} ${onBlog ? navActive : navGhost}`}>
              AI NEWS
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-slate-500 hover:text-slate-800"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-slate-100 bg-white">
          <div className="px-4 py-3 space-y-2">
            <a
              href="/"
              className={`block text-sm text-center rounded-full px-4 py-2 ${onHome ? navActive : navGhost}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              首页
            </a>
            <a
              href="/blog"
              className={`block text-sm text-center rounded-full px-4 py-2 ${onBlog ? navActive : navGhost}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              AI NEWS
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
